import styles from './Toast.module.scss';
import CheckmarkIcon from '@/assets/icons/checkmark-toast.svg?react';

interface IToastProps {
  message: string;
  checkmark: boolean;
  status: string;
}

const Toast = ({ message, checkmark, status }: IToastProps) => {
  return (
    <div className={`${styles.toast} ${styles[status]}`}>
      {checkmark && <CheckmarkIcon className={styles.svg} />}
      <span>{message}</span>
    </div>
  );
};

export default Toast;
